import React from "react";
import "./Footer.css";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* === Logo + CTA === */}
        <div className="footer-col footer-main">
          <img
            src="/images/safety-veratra.png"
            alt="VERATRAC SAFETY"
            className="footer-logo"
          />
          <a href="#contact" className="footer-btn">
            DEMANDER UN DEVIS
          </a>
          <p className="footer-slogan">
            Inspection, conformité et formation en toute sécurité.
          </p>
        </div>

        {/* === Domaines d’intervention === */}
        <div className="footer-col">
          <h3>DOMAINES D’INTERVENTION</h3>
          <ul>
            <li>Appareils de levage</li>
            <li>Appareils à pression</li>
            <li>Installations électriques</li>
            <li>Contrôles non destructifs (CND)</li>
            <li>Contrôle de construction</li>
            <li>Assistance & ingénierie</li>
            <li>Expertise maritime</li>
            <li>Formation — VERATRAC ACADEMY</li>
          </ul>
        </div>

        {/* === Contact + réseaux + localisation fusionnés === */}
        <div className="footer-col footer-contact">
          <h3>CONTACT</h3>
          <p><strong>VERATRAC SAFETY</strong></p>
          <p>Mohammedia, Maroc</p>
          <p>
            📧{" "}
            <a href="mailto:Souda.Veratrac@gmail.com">
              Souda.Veratrac@gmail.com
            </a>
          </p>
          <p>📞 +212 670 166 516</p>

          <div className="footer-social">
            <a
              href="https://www.linkedin.com/company/veratrac-safety-souda/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <img
                src="/images/linkedin.png"
                alt="LinkedIn"
                className="social-icon"
              />
            
            </a>
          </div>
        </div>
      </div>

      {/* === Bande inférieure === */}
      <div className="footer-bottom">
        <p>
          © {currentYear} VERATRAC SAFETY — Tous droits réservés. |{" "}
          <a href="#mentions-legales">Mentions légales</a> |{" "}
          <a href="#plan-site">Plan du site</a>
        </p>
        <p>
          Réalisation et éco-conception par{" "}
          <a href="https://www.dioga.fr" target="_blank" rel="noreferrer">
            Dioga
          </a>
        </p>
      </div>
    </footer>
  );
}
